import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductService } from '@services/product.service';

@Component({
  selector: 'gob-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent {
  @Input() isOpen = false;
  @Input() productName = '';
  @Input() productId = ''; // Reçoit product.ident

  @Output() closeEvent = new EventEmitter<void>();

  email = '';
  loading = false;
  msg = '';
  success = false;
  emailInvalid = false;

  // Regex de validation d'email
  private emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

  constructor(private pService: ProductService) {}

  /**
   * On utilise EXACTEMENT la même logique que ton ancienne méthode.
   * On appelle le service et on valide le succès immédiatement après l'envoi,
   * car ton PHP renvoie du texte qui fait paniquer le décodeur JSON d'Angular.
   */
  submitEmail(e: Event) {
    e.preventDefault();

    // Validation du format email
    if (!this.emailRegex.test(this.email)) {
      this.emailInvalid = true;
      return;
    }
    this.emailInvalid = false;

    if (this.email && this.productId) {
      this.loading = true;

      // On utilise productId et l'email du formulaire
      this.pService.setAlert(this.productId, this.email)
        .subscribe(
          (response: any) => {
            this.process(true);
          },
          () => {
            this.process(false);
          }
        );
    }
  }

  private process(success: boolean) {
    this.loading = false;
    if (success) {
      this.msg = "C'est noté ! Alerte enregistrée.";
      this.success = true;
    } else {
      this.msg = "L'alerte existe déjà !";
      this.success = false;
    }
    // On ferme la modale après un court délai
    setTimeout(() => this.close(), 2500);
  }

  close() {
    this.isOpen = false;
    this.msg = '';
    this.email = '';
    this.emailInvalid = false;
    this.closeEvent.emit();
  }
}